import type { CustomFont } from 'venn-state';

export const getCustomFontSize = (customFont: CustomFont): string => `${customFont.fontSizePt}pt`;
